// extracted by mini-css-extract-plugin
export default {"loadingSkeleton":"VlaJqTgQOuz3lNPbKMyG"};